var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"navbar navbar-light bg-light"},[_c('span',{staticClass:"navbar-brand mb-0 h1"},[_vm._v("G Members")]),_c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.logout}},[_vm._v("Sair")])])])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }